<script context='module'>
  export { default as SelectFilterOption } from '../Radio';
</script>

<script>
  import {
    always,
    equals,
    identity,
    when,
  } from 'ramda';
  import { filter } from 'fuzzyjs';
  import Filter from './Filter.svelte';
  import TextInput from '../TextInput';
  import RadioGroup from '../RadioGroup';

  export let name;
  export let search = undefined;
  export let tooltip = undefined;
  export let testid = undefined;
  export let print = identity;
  export let removable = true;

  $: iterator = search === true ? identity : search;

  let value;
  let query = '';
  const clear = () => {
    query = '';
  };
</script>

<Filter {name} bind:value on:dismiss={clear} {print} {testid} {tooltip} {removable}>
  {#if search}
    <TextInput
      name='filter-{name}'
      bind:value={query}
      leftIcon='search'
      placeholder='Search by {name}' />
  {/if}
  <div class='options'>
    <RadioGroup {value} on:change={(evt) => {
      value = when(equals(null), always(undefined), evt.detail);
    }}>
      <slot filter={filter(query, { iterator })} />
    </RadioGroup>
  </div>
</Filter>

<style>
  .options {
    min-height: 0;
    max-height: 300px;
    overflow-y: auto;
  }
</style>
